export const F_JOB_NAME_SEARCH = 'jobNameSearch';
export const F_EMPLOYMENT_TYPE = 'EmploymentType';
export const F_EMPLOYMENT_TIME = 'EmploymentTime';
export const F_CATEGORY = 'Category';
export const F_LOCATION = 'Location';
export const F_JOB = 'Job';
export const F_EDUCATION_LEVEL = 'EducationLevel';
export const F_EMPLOYING_COMPANY = 'employingCompany';
